// extracted by mini-css-extract-plugin
export default {"Link":"Logo_Link__R4QwR","Name":"Logo_Name__0zFHM","Brand":"Logo_Brand__yfPer","FNLogo":"Logo_FNLogo__-9Sl4"};